import {Controller} from '@hotwired/stimulus';
import GLightbox from 'glightbox';

export default class extends Controller {
    open(event) {
        event.preventDefault();

        const images = JSON.parse(this.element.dataset.images || '[]');
        const lightbox = GLightbox({
            elements: images.map(href => ({href, type: 'image'})),
            touchNavigation: true,
            loop: true,
        });
        lightbox.on('close', () => lightbox.destroy());
        lightbox.open();
    }
}
